import faturamentosRotas from './faturamentos/FaturamentosRotas'
import acionRecebRotas from './acionamentosrecebimentos/AcionRecebRotas'
import importacoesRotas from './importacoes/ImportacoesRotas'
import parcelasRotas from './parcelas/ParcelasRotas'

export default {
    path: 'paineis',
    name: 'Paineis',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        faturamentosRotas,
        acionRecebRotas,
        importacoesRotas,
        parcelasRotas
    ]
}



// WEBPACK FOOTER //
// ./src/modulos/paineis/PaineisRotas.js